import { Group, Paper, SimpleGrid, Text } from "@mantine/core";
import {
  IconTransform,
  IconPackages,
  IconFreezeColumn,
} from "@tabler/icons-react";
import { useTranslation } from "react-i18next";
import classes from "./StatsGrid.module.css";

const icons = {
  packages: IconPackages,
  column: IconFreezeColumn,
  transform: IconTransform,
};

const data = [
  { title: "stats.totalSkus", icon: "packages", value: "0" },
  { title: "stats.attributes", icon: "column", value: "0" },
  { title: "stats.mappings", icon: "transform", value: "-" },
];

export function StatsGrid({ importData, mappings, vertical }) {
  const { t } = useTranslation("imports");
  data[0].value = importData?.rowCount ?? 0;
  data[1].value = importData?.columns?.length ?? 0;
  data[2].value = mappings?.length ?? 0;

  const stats = data.map((stat) => {
    const Icon = icons[stat.icon];

    return (
      <Paper withBorder p="md" radius="md" key={stat.title}>
        <Group justify="space-between">
          <Text size="xs" c="dimmed" className={classes.title}>
            {t(stat.title)}
          </Text>
          <Icon className={classes.icon} size="1.4rem" stroke={1.5} />
        </Group>
        <Group align="flex-end" gap="xs" mt={25}>
          <Text fz="xl" className={classes.value}>
            {stat.value}
          </Text>
        </Group>
      </Paper>
    );
  });
  return (
    <div className={classes.root}>
      <SimpleGrid cols={{ base: vertical ? 1 : 3 }}>{stats}</SimpleGrid>
    </div>
  );
}
